import script from "./SessionMoveDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionMoveDialog.vue?vue&type=script&setup=true&lang=js"

import "./SessionMoveDialog.vue?vue&type=style&index=0&id=c961bd78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c961bd78"]])

export default __exports__